import React from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const { nodes, materials } = useGLTF('/hockey_stick.glb')
  return (
    <group  {...props} dispose={null}>
      <mesh castShadow  geometry={nodes.Cylinder.geometry} material={nodes.Cylinder.material} />
      <mesh
        castShadow 
        geometry={nodes.pCube2_initialShadingGroup1_0.geometry}
        material={materials.initialShadingGroup1}
        position={[0, 0.2, 0]} 
      />
    </group>
  )
}

useGLTF.preload('/hockey_stick.glb')
